export { default } from './Prequalified';
